
import axiosInstanceSeascape from '../../shared/api/axiosInstanceSeascape';
import { ISeascapeActivityLog } from './activityLogTypes';

export const addSeascapeLogActivity = async (activityLog: ISeascapeActivityLog) => {
    const endpoint = '/seascapeactivitylogs/add-log';

    await axiosInstanceSeascape.post(endpoint, {
        eventId: activityLog.eventId,
        payload: activityLog.payload,
    });
};


